// web-v2/src/lib/search-rows.js
//
// THE ONE DERIVATION OF A SEARCH RESULT'S ROWS AND ITS LINK (2026-11-02, David's step 15 finding 1). /search and the Cmd+K
// palette (components/shared/SearchPalette.jsx) both render GET /api/tracon/search through these two functions and never
// build a link of their own: the /search page used to send every row, an account row too, to
// /account/<account id>/deal/<row id>, so an account result opened a "deal" whose id was the ACCOUNT's Zoho id ("Deal not
// found"). The server (utils/search-hit.js) names each row's link in `href`; these fall back to the same routes only when a
// row carries none.
//   account -> /account/<account id> (the client record)
//   term    -> that deal under its insured: /account/<account id>/deal/<deal id>
//   deal    -> a hit with no account: /account/<account id or deal id>/deal/<deal id> (routes/account.jsx heals a deal id in
//              the account slot to the deal's own account)
// The app's deal URL is /account/<account>/deal/<deal>; there is no bare /deal/<id> route.

export const INLINE_TERMS = 3;

// The rows of a result set: each account row, then each of its visible nested terms (all of them when `expanded` is true,
// else the first INLINE_TERMS unless that account is in the `expanded` Set), then any loose deal rows.
export function flattenRows(results, expanded) {
  const rows = [];
  for (const r of results || []) {
    if (r.type === 'account') {
      rows.push({ kind: 'account', key: `a:${r.id}`, r });
      const terms = r.terms || [];
      const visible = expanded === true || expanded?.has?.(r.id) ? terms : terms.slice(0, INLINE_TERMS);
      for (const t of visible) rows.push({ kind: 'term', key: `t:${r.id}:${t.id}`, r, t });
    } else {
      rows.push({ kind: 'deal', key: `d:${r.id}`, r });
    }
  }
  return rows;
}

// Where a row goes: an account row's id is the ACCOUNT, never a deal.
export function hrefForRow(row) {
  if (!row) return null;
  if (row.kind === 'account') return row.r.href || `/account/${encodeURIComponent(row.r.id)}`;
  if (row.kind === 'term') return row.t.href || `/account/${encodeURIComponent(row.r.id)}/deal/${encodeURIComponent(row.t.id)}`;
  return row.r.href || `/account/${encodeURIComponent(row.r.account_id || row.r.id)}/deal/${encodeURIComponent(row.r.id)}`;
}
